
/* The INTERNAL Feature Flags are handling features only accessible within the company network */
export var INTERNAL_FEATURE_KEY = 'internal';
export var INTERNAL_COOKIE_FEATURE_NAMES = ['features'];
export var INTERNAL_BROWSER_FEATURE_QUERY_KEYS = ['feature[]'];
export var INTERNAL_SERVER_FEATURE_QUERY_KEY = 'feature';

/* The PUBLIC Feature Flags are handling features accessible by all of the visitors */
export var PUBLIC_FEATURE_KEY = 'public';
export var PUBLIC_COOKIE_FEATURE_NAMES = ['wh-sb-abFeatures', 'wh-com-abFeatures'];
export var PUBLIC_BROWSER_FEATURE_QUERY_KEYS = ['abFeature[]', 'abComFeature[]'];
export var PUBLIC_SERVER_FEATURE_QUERY_KEY = 'abFeature';

export var DEFAULT_FEATURE_KEY = INTERNAL_FEATURE_KEY;